export default "__VITE_PUBLIC_ASSET__30c9801f__"